import React from 'react'

import Svg, {
  ClipPath,
  Defs,
  G,
  Path,
  RadialGradient,
  Rect,
  Stop,
} from 'react-native-svg'

const CoinBag = ({ color = '#F2F7FF', ...props }: { color?: string }) => {
  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      fill="none"
      {...props}
    >
      <G clipPath="url(#a)">
        <Rect width={48} height={48} fill={color} rx={8} />
        <Path
          fill="url(#b)"
          d="M32.45 29.808a.713.713 0 0 1-.51-.209c-1.907-1.924-5.907-1.953-5.943-1.953a.715.715 0 0 1-.716-.72.723.723 0 0 1 .716-.72c.187 0 4.624 0 6.961 2.37a.721.721 0 0 1-.509 1.232Z"
        />
        <Path
          fill="url(#c)"
          d="M8.076 29.808a.714.714 0 0 1-.666-.443.724.724 0 0 1 .157-.79c2.337-2.341 6.774-2.37 6.96-2.37a.715.715 0 0 1 .718.72.715.715 0 0 1-.717.72c-.036.001-4.036.001-5.943 1.954a.717.717 0 0 1-.51.21Z"
        />
        <Path
          fill="url(#d)"
          d="M25.28 29.088h-3.584l-1.433-11.53c2.787-.961 5.814-.961 8.602 0-1.434 5.044-2.15 7.206-3.584 11.53Z"
        />
        <Path
          fill="url(#e)"
          d="M15.245 29.088h3.584l1.434-11.53a13.197 13.197 0 0 0-8.603 0c1.434 5.044 2.15 7.206 3.585 11.53Z"
        />
        <Path
          fill="url(#f)"
          d="M23.13 25.485h-5.735l-1.434-11.53c2.788-.961 5.815-.961 8.603 0l-1.434 11.53Z"
        />
        <Path
          fill="url(#g)"
          d="M34.6 44.581c0 7.927-6.452 7.567-14.338 7.567-7.885 0-14.337.36-14.337-7.567 0-7.927 6.452-19.096 14.337-19.096 7.886 0 14.338 11.17 14.338 19.096Z"
        />
        <Path
          fill="url(#h)"
          d="M25.997 25.34h-11.47c-.791 0-1.433.646-1.433 1.442 0 .796.642 1.441 1.434 1.441h11.47c.791 0 1.433-.645 1.433-1.441s-.642-1.441-1.434-1.441Z"
        />
        <G clipPath="url(#i)">
          <Path
            fill="url(#j)"
            d="M26.804 39.942c0 3.607-2.908 6.53-6.496 6.53a6.464 6.464 0 0 1-4.782-2.109 6.527 6.527 0 0 1-1.715-4.421c0-3.607 2.909-6.53 6.497-6.53a6.438 6.438 0 0 1 4.398 1.724 6.527 6.527 0 0 1 2.098 4.806Z"
          />
          <Path
            fill="#fff"
            d="M22.976 38.388h-.884a2.147 2.147 0 0 0-.23-.558h1.114c.293 0 .53-.239.53-.533a.532.532 0 0 0-.53-.533h-5.011a.532.532 0 0 0-.53.533c0 .294.238.533.53.533h2.047c.406 0 .76.225.947.558h-2.994a.532.532 0 0 0-.53.533c0 .294.238.533.53.533h2.994c-.186.333-.54.558-.947.558h-2.047a.535.535 0 0 0-.386.899l2.885 3.077a.527.527 0 0 0 .75.023.535.535 0 0 0 .022-.754l-2.042-2.179h.818c1 0 1.843-.692 2.08-1.624h.884c.293 0 .53-.239.53-.533a.532.532 0 0 0-.53-.533Z"
          />
        </G>
        <G clipPath="url(#k)">
          <Path
            fill="url(#l)"
            d="M42.013 35.913v1.68c0 .458-.367.83-.822.83h-9.843a.826.826 0 0 1-.822-.83v-1.68c0-.457.368-.828.822-.828h9.843c.454 0 .822.37.822.828Z"
          />
          <Path
            fill="url(#m)"
            d="M40.537 39.252v1.68c0 .458-.368.83-.822.83h-9.843a.826.826 0 0 1-.822-.83v-1.68c0-.458.368-.829.822-.829h9.843c.454 0 .822.371.822.83Z"
          />
          <Path
            fill="url(#n)"
            d="M41.09 42.59v1.68c0 .458-.367.83-.821.83h-9.843a.826.826 0 0 1-.822-.83v-1.68c0-.457.368-.829.822-.829h9.843c.454 0 .822.372.822.83Z"
          />
          <Path
            fill="url(#o)"
            d="M40.537 45.929v1.68c0 .458-.368.83-.822.83h-9.843a.826.826 0 0 1-.822-.83v-1.68c0-.458.368-.83.822-.83h9.843c.454 0 .822.372.822.83Z"
          />
          <Path
            fill="url(#p)"
            d="M40.537 32.575v1.68c0 .458-.368.83-.822.83h-9.843a.826.826 0 0 1-.822-.83v-1.68c0-.458.368-.83.822-.83h9.843c.454 0 .822.372.822.83Z"
          />
        </G>
      </G>
      <Defs>
        <RadialGradient
          id="b"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(146.556 11.531 18.326) scale(5.25361 13.7308)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="c"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(146.556 2.568 15.633) scale(5.25361 13.7308)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="d"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-2.90946 6.16532 -5.25282 -2.47885 27.858 19.175)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="e"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-1.44071 5.94113 -5.05959 -1.22694 17.787 19.4)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="f"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-2.90946 6.16532 -5.25282 -2.47885 23.556 15.572)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#3D7FEB" />
        </RadialGradient>
        <RadialGradient
          id="g"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="rotate(135.075 10.582 20.312) scale(34.1972 31.8015)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#9DC2FF" />
          <Stop offset={1} stopColor="#235DBC" />
        </RadialGradient>
        <RadialGradient
          id="h"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 2.87538 -22.7236 0 19.444 25.387)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="j"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(-7.21942 10.49569 -27.85248 -19.15823 23.646 37.242)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="l"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 3.33 -18.2059 0 35.614 35.139)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="m"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 3.33 -18.2059 0 34.138 38.477)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="n"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 3.33 -18.2059 0 34.691 41.816)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="o"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 3.33 -18.2059 0 34.138 45.154)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <RadialGradient
          id="p"
          cx={0}
          cy={0}
          r={1}
          gradientTransform="matrix(0 3.33 -18.2059 0 34.138 31.8)"
          gradientUnits="userSpaceOnUse"
        >
          <Stop stopColor="#FFE0B9" />
          <Stop offset={0.908} stopColor="#D1A368" />
          <Stop offset={1} stopColor="#DCAD70" />
        </RadialGradient>
        <ClipPath id="a">
          <Rect width={48} height={48} fill="#fff" rx={8} />
        </ClipPath>
        <ClipPath id="i">
          <Path fill="#fff" d="M13.81 33.411h12.994v13.061H13.81z" />
        </ClipPath>
        <ClipPath id="k">
          <Path fill="#fff" d="M29.05 31.8H42v16.65H29.05z" />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default CoinBag
